<label class="ice-radio-list-item-container" [for]="value">
  <div class="content">
    <div class="main-content">
      <span>{{ label }}</span>
      <div class="right-content">
        <ng-content select="[inlineContent]" />
      </div>
    </div>
    <ng-content select="[content]" />
  </div>

  <input
    #checkboxInput
    type="radio"
    [attr.data-testid]="testId()"
    [formControl]="formControl"
    [id]="value"
    [value]="value"
  />
</label>
